import { render, staticRenderFns } from "./PracticalAssessmentScoreInquiry.vue?vue&type=template&id=22202888&scoped=true"
import script from "./PracticalAssessmentScoreInquiry.vue?vue&type=script&lang=js"
export * from "./PracticalAssessmentScoreInquiry.vue?vue&type=script&lang=js"
import style0 from "./PracticalAssessmentScoreInquiry.vue?vue&type=style&index=0&id=22202888&prod&lang=stylus&scoped=true"
import style1 from "./PracticalAssessmentScoreInquiry.vue?vue&type=style&index=1&id=22202888&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22202888",
  null
  
)

export default component.exports